/** @jsx jsx */
import { jsx, useThemeUI } from "@trueskin-web/theme"
import RebrandedTheme from "@trueskin-web/theme/rebranded-theme"

const sizes = {
  md: {
    width: 222,
    height: 22,
  },
  sm: {
    width: 171,
    height: 16,
  },
  xsm: {
    width: 141,
    height: 30,
  },
}

const Logo = ({ className, color = "primary", size = "md" }) => {
  const {
    theme: { name: themeName },
  } = useThemeUI()

  const isRebrandedTheme = themeName === RebrandedTheme.name

  const baseStyles = {
    display: "block",
    mt: ["2px", 0],
    mb: ["2px", "4px"],
    ...sizes[size],
  }

  if (isRebrandedTheme) {
    return (
      <svg
        width="132"
        height="15"
        viewBox="0 0 132 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        sx={baseStyles}
        className={className}
      >
        <g>
          <path
            d="M57.2398 0.260725V14.1919H67.5666V11.8243H60.0784V8.34087H66.5907V6.02487H60.0784V2.64601H67.5138V0.260725H57.2398ZM40.3138 0.260725V14.1919H42.8917V6.21631C42.8917 5.10176 42.7871 3.34245 42.7871 3.34245H42.8224C42.8224 3.34245 43.136 4.97962 43.4495 5.97202L45.7831 14.1919H48.482L50.9025 5.97202C51.1809 4.97962 51.4944 3.34245 51.4944 3.34245H51.5297C51.5297 3.34245 51.4075 5.10176 51.4075 6.21631V14.1919H54.0371V0.260725H49.997L48.0463 7.26156C47.5413 9.01969 47.176 11.0233 47.176 11.0233H47.1408C47.1408 11.0233 46.7579 9.02087 46.2705 7.26156L44.2857 0.260725H40.315H40.3138ZM29.3774 6.25154V2.54266H32.6341C34.1492 2.54266 34.6894 3.04767 34.6894 4.35365C34.6894 5.65962 34.1151 6.25154 32.5648 6.25154H29.3786H29.3774ZM26.5564 0.260725V14.1919H29.3774V8.42778H32.1984C34.1139 8.42778 34.4099 8.96802 34.4099 10.9704C34.5144 12.4855 34.5496 14.0357 34.8973 14.1919H37.6137V14.0522C37.1264 13.8431 37.1956 12.3457 37.0218 10.3773C36.8304 8.49707 36.3606 7.76539 35.0535 7.39897V7.32968C36.8468 6.84228 37.4388 5.6056 37.4388 3.98605C37.4388 1.47862 35.8192 0.259551 33.138 0.259551H26.5552L26.5564 0.260725ZM17.8315 12.1719C15.0974 12.1719 14.1567 10.0121 14.1567 7.26156C14.1567 4.51102 15.0974 2.31599 17.8315 2.31599C20.5656 2.31599 21.4711 4.47579 21.4711 7.26156C21.4711 10.0473 20.5656 12.1719 17.8315 12.1719ZM17.7963 14.5055C22.0971 14.5055 24.3261 11.4238 24.3261 7.26156C24.3261 3.09935 22.0982 0 17.7974 0C13.4966 0 11.2676 3.09935 11.2676 7.26156C11.2676 11.4238 13.5483 14.5055 17.7974 14.5055M72.8258 11.789H79.9652V14.1919H69.9871V0.260725H72.8258V11.789ZM85.0094 3.28256V5.31904H82.0615V8.34087H79.9652V5.31904H77.0326V3.28256H79.9652V0.260725H82.0615V3.28256H85.0094ZM93.4372 14.5055C89.5192 14.5055 87.5333 12.8331 87.4464 9.89113H90.1981C90.4071 11.5624 91.1905 12.2247 93.315 12.2247C94.9522 12.2247 96.0315 11.7197 96.0315 10.4314C96.0315 9.07254 94.7079 8.7942 92.601 8.30681C90.1111 7.73251 87.8292 7.07012 87.8292 4.19745C87.8292 1.32477 89.9009 0.0176166 93.1576 0.0176166C96.4144 0.0176166 98.3123 1.55026 98.5213 4.35365H95.8048C95.6486 2.96076 94.742 2.26432 93.14 2.26432C91.4512 2.26432 90.6326 2.89147 90.6326 3.90149C90.6326 5.03365 91.6074 5.36366 93.645 5.817C96.5177 6.42653 98.8689 7.10536 98.8689 10.1014C98.8689 12.94 96.762 14.5067 93.436 14.5067M113.117 14.1931H109.913L105.697 7.3332L103.905 9.12539V14.1931H101.066V0.260725H103.905V5.83344L109.251 0.260725H112.768L107.635 5.53161L113.117 14.1919V14.1931ZM114.723 0.2619H117.544V14.1931H114.723V0.260725V0.2619ZM123.618 0.2619L128.232 8.02847C128.684 8.7942 129.207 9.97921 129.207 9.97921H129.242C129.242 9.97921 129.173 8.55109 129.173 7.57631V0.260725H131.959V14.1919H129.225L124.488 6.49465C124.036 5.76297 123.496 4.57914 123.496 4.57914H123.443C123.443 4.57914 123.53 6.04132 123.53 6.99966V14.1919H120.744V0.260725H123.617L123.618 0.2619ZM9.97921 0.2619V2.6648H2.83862V5.92152H8.88111V8.34204H2.83862V14.1931H0V0.260725H9.97803L9.97921 0.2619Z"
            fill="black"
          />
        </g>
        <defs>
          <clipPath>
            <rect width="132" height="14.5055" fill="white" />
          </clipPath>
          <clipPath>
            <rect width="131.959" height="14.5055" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-1 0 730 80.87"
      sx={{
        ...baseStyles,
        fill: color,
      }}
      className={className}
    >
      <path
        d="M0,3.26h45.7v8.47H8.9v27.14h33.76v8.03H8.9v32.35H0V3.26z M89.56,1.63c-19.21,0-32.02,15.85-32.02,39.62
	c0,23.77,12.81,39.62,32.02,39.62s32.02-15.85,32.02-39.62C121.58,17.48,108.78,1.63,89.56,1.63z M89.56,72.4
	c-14.22,0-23.01-11.94-23.01-31.15S75.34,10.1,89.56,10.1c14.22,0,23.01,11.94,23.01,31.15S103.78,72.4,89.56,72.4z M169.77,47.76
	c11.94-1.95,19-9.99,19-22.03c0-14-9.44-22.47-25.29-22.47h-27.68v75.98h8.9V48.41h15.2l16.07,30.83h10.53l-16.72-31.26V47.76z
	 M144.7,39.95V11.72h18.02c11.29,0,17.04,4.78,17.04,14c0,9.33-5.86,14.22-17.04,14.22H144.7z M204.73,3.26h11.94l24.64,60.35h0.22
	l24.64-60.35h11.94v75.98h-9.01V17.59h-0.22l-25.62,61.66h-3.8l-25.62-61.66h-0.22v61.66h-8.9V3.26z M296.66,3.26h45.59v8.47h-36.69
	v24.31h33.65v8.03h-33.65v26.7h36.69v8.47h-45.59V3.26z M357.55,3.26h8.9v67.52h34.3v8.47h-43.2V3.26z M460.97,54.06l9.12-1.63
	c1.85,14.11,8.68,19.97,22.9,19.97c11.07,0,17.69-5.43,17.69-12.26c0-7.6-5.32-11.83-21.38-16.83
	c-18.34-5.75-24.97-11.29-24.97-21.38c0-11.51,9.77-20.3,25.29-20.3c14.55,0,24.97,9.01,27.79,22.14l-8.68,1.95
	c-2.82-10.64-9.33-15.63-19.21-15.63c-10.1,0-16.28,5.32-16.28,11.61c0,5.75,4.67,8.9,19.1,13.57c19.86,6.3,27.25,12.92,27.25,24.64
	c0,12.48-10.75,20.95-26.7,20.95C473.45,80.87,463.58,71.53,460.97,54.06z M535.43,0h8.47v49.06h0.22l31.48-27.35h13.24
	l-27.57,23.55l28.77,33.98h-11.61l-23.66-28.55h-0.22l-10.64,9.33v19.21h-8.47V0z M658.51,71.32v7.92h-54.27v-7.92h22.9V29.63
	h-21.82v-7.92h30.29v49.61H658.51z M636.48,12.27h-10.2V2.17h10.2V12.27z M676.42,21.71h8.47v6.4h0.22c4.45-5.1,11.51-8.03,19-8.03
	c14.87,0,23.88,9.44,23.88,24.64v34.52h-8.47V47c0-12.16-5.75-19-16.06-19c-11.18,0-18.56,7.16-18.56,18.24v33h-8.47V21.71z
	 M420.5,1.63c-12.29,0-22.25,9.96-22.25,22.25c0,12.29,9.96,22.25,22.25,22.25c12.29,0,22.25-9.96,22.25-22.25
	C442.75,11.59,432.79,1.63,420.5,1.63z M433.85,28.33h-8.9v8.9h-8.9v-8.9h-8.9v-8.9h8.9v-8.9h8.9v8.9h8.9V28.33z"
      />
    </svg>
  )
}

export default Logo
